export default __webpack_public_path__ + "static/broadcastImg2-2bc2f32f210ce6b9047baf0ebaf63126.webp";